import axios from 'axios';
import { API_URL, COMPANY_POLLS_SELECTION_PARAMS } from '@/constants';
const CancelToken = axios.CancelToken;
const source = CancelToken.source();
const instance = axios.create({
  baseURL: `${API_URL}`,
  cancelToken: source.token
});

export async function getCompanyPolls () {
  const polls = COMPANY_POLLS_SELECTION_PARAMS.map((pollParam) => {
    return instance.get(`poll${pollParam}`)
  });
  // return axios.all([
  //   instance.get(`poll/22`), // base
  //   instance.get(`poll/20`), // extended
  //   instance.get(`poll/21`) // categories
  // ]);
  return axios.all(polls);
}

export async function getUserId () {
  return instance.get(`user_id`).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled', thrown.message);
    } else {
      throw thrown
    }
  });
}

export async function deleteUser (userId) {
  return instance.delete(`user/${userId}`).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled', thrown.message);
    } else {
      throw thrown
    }
  });
}

// export async function getUserPoll (pollId) {
//   return instance.get(`profile`).catch(function (thrown) {
//     if (axios.isCancel(thrown)) {
//       console.log('Request canceled', thrown.message);
//     } else {
//       throw thrown
//     }
//   });
// }

// export async function setUserPoll (data) {
//   return instance.post(`user`, data).catch(function (thrown) {
//     if (axios.isCancel(thrown)) {
//       console.log('Request canceled', thrown.message);
//     } else {
//       throw thrown
//     }
//   });
// }

export async function getPoll (pollId) {
  return instance.get(`poll/${pollId}`).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled', thrown.message);
    } else {
      throw thrown
    }
  });
}

export async function sendAnswers (answersArray) {
  return instance.post('answer', answersArray).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled', thrown.message);
    } else {
      throw thrown
    }
  });
}

export async function deleteUploadedFile (fileId) {
  return instance.delete(`answer/${fileId}`).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled', thrown.message);
    } else {
      throw thrown
    }
  });
}

export async function emitCreateExel (userId) {
  return instance.post(`user_serializer`, { user: userId }).catch(function (thrown) {
    if (axios.isCancel(thrown)) {
      console.log('Request canceled', thrown.message);
    } else {
      throw thrown
    }
  });
}
